exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-wrapper[data-v-4d3a109a] {\n  z-index: 1000 !important;\n}\n.modal-wrapper[data-v-4d3a109a] .modal {\n  z-index: 1000 !important;\n}\n", ""]);

// exports
